<template>
  <div>
    <div class="tb-form-group">
      <label
        class="tb-label"
        for="cycleSpeedInput"
      >
        Cycle Speed (1 - 100 seconds)
      </label>

      <input
        id="cycleSpeedInput"
        type="number"
        class="tb-input"
        v-model.number.lazy="cycleSpeed"
        min="1"
        max="100"
        data-entity="producer-editor-cycleSpeed"
        data-test="graphics-editor-cycleSpeed"
        @keyup.right.stop
        @keyup.left.stop
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // Graphic layer
    element: {
      type: Object,
      required: true,
    },

    // Override fields
    graphic_fields: {
      type: Object,
      required: true,
    },

    // Timeline Item
    graphic: {
      type: Object,
      required: true,
    },
  },

  computed: {
    timelineId() {
      return this.graphic.timeline_id;
    },

    elementFields() {
      return this.graphic_fields[this.element.id];
    },

    cycleSpeed: {
      get() {
        const cycleSpeed = this.elementFields?.cycleSpeed ?? this.element.cycleSpeed;
        return Math.floor(cycleSpeed / 1e3);
      },

      set(value) {
        // Force into 1-100 range
        this.updateField(
          'cycleSpeed',
          Math.min(Math.max(value || 1, 1), 100) * 1e3,
        );
      },
    },
  },

  methods: {
    updateField(field, value) {
      this.$emit('value', { field, value });
    },
  },
};
</script>
